.root {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.heading {
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  align-items: flex-start;
  background: var(--color-card);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  text-align: left;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
  width: 100%;
}

.item:hover {
  background: var(--color-accent);
  border-color: var(--color-accent-border);
}

.item:focus-visible {
  border-color: var(--color-primary);
  outline: 2px solid var(--color-primary);
  outline-offset: 1px;
}

.icon {
  color: var(--color-muted-foreground);
  flex-shrink: 0;
  line-height: 1;
  padding-top: 2px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.example {
  font-style: italic;
}
